import React from "react"
import styled from "styled-components"
import {WithImage} from "@irati/ui/src/Modal"
import image from "@irati/ui/images/mfa.png"

interface ImageProps {
  size: number
}

const ProfileNoBorder = styled.div<ImageProps>`
  position: absolute;

  ${({size}) => `
    top: -${size / 2 + 5}px;
    width: ${size}px;
    height: ${size}px;
  `}
`

interface Props {
  size: number
}

const ModalHeader: React.FC<Props> = ({children, size}) => {
  return (
    <WithImage size={size} image={image}>
      <ProfileNoBorder size={size}>{children}</ProfileNoBorder>
    </WithImage>
  )
}

export default ModalHeader
